"use client";

import Image from "next/image";
import React from "react";
import Link from "next/link";
import Button from "./Button";

interface BlogCardProps {
  image: string;
  date: string;
  title: string;
  slug?: string;
}

const EbooksCard: React.FC<BlogCardProps> = ({
  image,
  date,
  title,
  slug = "ebooks-post",
}) => {
  return (
    <Link href={`/blog/${slug}`} className="block group">
      <div className="w-full bg-transparent overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-xl">
        {/* Top Image */}
        <div className="relative w-full aspect-video overflow-hidden">
          <Image
            src={image}
            alt="Blog thumbnail"
            fill
            className="object-cover transition-transform duration-500 group-hover:scale-110"
            quality={100}
          />
          {/* Overlay effect */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
        </div>

        {/* Content Card */}
        <div className="m-4">
          <div className="bg-white/80 backdrop-blur-md px-6 py-4 text-[#333] -mt-16 relative z-50 shadow-[0_4px_8px_0_rgba(0,0,0,0.03)] transition-all duration-300 group-hover:bg-white/90 group-hover:shadow-[0_8px_25px_0_rgba(0,0,0,0.1)]">
            {/* Date & Category */}
            <div className="flex justify-between items-center mb-2">
              <span className="font-semibold text-[#1b1b1b] transition-colors duration-300 group-hover:text-[#272D57]">{date}</span>
            

              <Button variant="secondary" size="sm">
                Download
              </Button>
            </div>

            {/* Title */}
            <h3 className="text-[#272D57] text-xl font-semibold leading-tight mb-2 transition-all duration-300 group-hover:text-[#E0301E]">
              {title}
            </h3>

          </div>
        </div>
      </div>
    </Link>
  );
};

export default EbooksCard;
